'use client';

import React, { useEffect, useState } from 'react';
import { loadingService } from '_services/loading.service';
import { Modal } from 'react-bootstrap';

import styles from '@/styles/menu.module.scss'

import LoadingAnime from '@/assets/lotties/pizza_loader.json'
import Lottie from 'lottie-react';

export default function LoadingIndicator(){
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const subscription = loadingService.onLoading().subscribe((loading) => {
            // console.log('Loading state received:', loading);
            setLoading(loading.isShow);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    return (
        <>
            {loading && <Modal show={loading} className={styles.loadingModal} centered backdrop="static" keyboard={false}>
                <Modal.Body>
                    <div className="loading-indicator">
                        <Lottie animationData={LoadingAnime} className={styles.loadingAnimation} loop={true} />
                    </div>
                </Modal.Body>
            </Modal>}
        </>
    );
}

